import React from 'react';

import Icon from 'components/Icon';

import Main from '../MobileVersion/MobileVersion.styled';

const SWUnsupported = () => (
  <Main>
    <div className="head">
      <Icon name="logo" />
    </div>
    <div className="body center">
      <img
        src="/assets/img/broken-browser.svg"
        alt="broken browser"
        width="350px"
      />
      <h2>Browser unsupported</h2>
      <p style={{ opacity: '0.7' }}>
        Some of the features that ruttl requires are not available on this
        browser.
        {typeof InstallTrigger !== 'undefined' && (
          <>
            <br />
            If this is Firefox&apos;s private window, please use a regular
            window.
          </>
        )}
        <br />
        <br />
        Tested on: Latest versions of Google Chrome, Safari, Microsoft Edge and
        Mozilla Firefox
      </p>
    </div>
    <div className="footer" />
  </Main>
);

export default SWUnsupported;
